import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { CircleAlert } from 'lucide-react';
import { useErrorText } from '@/lib/error-text';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="font-heading text-lg font-medium">{t('routes.notFoundTitle')}</p>
      <p className="text-sm text-muted-foreground">{t('routes.notFoundHint')}</p>
      <Button render={<Link to="/" />}>{t('routes.toStart')}</Button>
    </div>
  );
}

export function RouteErrorPage({ error, reset }: { error: unknown; reset: () => void }) {
  const { t } = useTranslation();
  const errorText = useErrorText();
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center">
      <CircleAlert className="size-6 text-destructive" />
      <p className="text-sm">{errorText(error)}</p>
      <Button variant="outline" onClick={reset}>
        {t('routes.retry')}
      </Button>
    </div>
  );
}
